import { render, staticRenderFns } from "./FormationsParametersTab.vue?vue&type=template&id=2ab94f8e&"
import script from "./FormationsParametersTab.vue?vue&type=script&lang=js&"
export * from "./FormationsParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports